import { invoke } from '@shared/easyfy.decorators';
import { Filter } from '@clientWebModules/filter';
import { FilterFor } from '@clientShared/filter.types';
import ToggleCss from '@shared/easyfy.togglecss';
import ScrollTo from '@shared/easyfy.scrollto';
import '@clientWebModules/sorter';

@invoke
export default class ArticleList {
  static Instance: ArticleList;

  constructor() {
    ArticleList.Instance = this;
    new ToggleCss('togglecss');
    new ScrollTo('smooth', true);
  }

  onInit() {
    new Filter(
      FilterFor.Articles,
      '[data-container="filter"]',
      '[data-container="paging"]',
      '[data-container="articles"]',
      '[data-container="sorter"]',
      '[data-container="selected-filters"]',
      true
    );
  }
}
